import React, { Component } from 'react';

class CountdownTimer extends Component {
  constructor(props) {
    super(props);
    // Set the target date for October 3rd, 2023
    this.targetDate = new Date('2023-10-17T09:00:00');
    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }

  componentDidMount() {
    // Update the countdown every second
    this.interval = setInterval(this.updateCountdown, 1000);
  }

  componentWillUnmount() {
    // Clear the interval to avoid memory leaks
    clearInterval(this.interval);
  }

  updateCountdown = () => {
    const now = new Date().getTime();
    const timeRemaining = this.targetDate - now;

    if (timeRemaining <= 0) {
      // Countdown has reached or passed the target date
      clearInterval(this.interval);
      this.setState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
    } else {
      // Calculate days, hours, minutes, and seconds remaining
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      this.setState({
        days,
        hours,
        minutes,
        seconds,
      });
    }
  };

  render() {
    const { days, hours, minutes, seconds } = this.state;

    const timerItemStyle = {
      textAlign: 'center',
      margin: "10px",
      padding: "5px",
      backgroundColor: "white",
      border: "solid white 1px",
      borderRadius: "6px",
      width: "70px"
    };

    const timerValueStyle = {
      fontSize: '40px', // Adjust the font size as needed
    //   fontWeight: '',
    };

    const timerLabelStyle = {
      fontSize: '16px', // Adjust the font size as needed
    };

    return (
      <div className="countdown-timer" style={{display: "flex",justifyContent: 'center'}}>
        <div className="timer-item" style={timerItemStyle}>
          <div className="timer-value big-font" style={timerValueStyle}>{days}</div>
          <div className="timer-label" style={timerLabelStyle}>Days</div>
        </div>
        <div className="timer-item" style={timerItemStyle}>
          <div className="timer-value big-font" style={timerValueStyle}>{hours}</div>
          <div className="timer-label" style={timerLabelStyle}>Hours</div>
        </div>
        <div className="timer-item" style={timerItemStyle}>
          <div className="timer-value big-font" style={timerValueStyle}>{minutes}</div>
          <div className="timer-label" style={timerLabelStyle}>Minutes</div>
        </div>
        <div className="timer-item" style={timerItemStyle}>
          <div className="timer-value big-font" style={timerValueStyle}>{seconds}</div>
          <div className="timer-label" style={timerLabelStyle}>Seconds</div>
        </div>
      </div>
    );
  }
}

export default CountdownTimer;
